import * as React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FaSpinner from 'react-icons/fa/spinner';

interface INavigationBarProps {
  submitting?: boolean;
  submitFailed?: boolean;
  valid?: boolean;
  hasBackButton?: boolean;
  hasNextButton?: boolean;
  nextButtonText?: string;
  backTo?: string;
  isInPaymentPage?: boolean;
  onClickSubmit?: () => void;
  saveQuoteModal ?: any;
  nextButtonDisabled?: boolean;
}

class NavigationBar extends React.Component<INavigationBarProps> {
  public static defaultProps: Partial<INavigationBarProps> = {
    hasNextButton: true,
    saveQuoteModal: '',
    nextButtonText: 'Page Suivante',
    nextButtonDisabled: false,
  };

  public render() {
    const {
      submitting,
      submitFailed,
      valid,
      hasBackButton,
      backTo,
      isInPaymentPage,
      onClickSubmit,
      hasNextButton,
      saveQuoteModal,
      nextButtonText,
      nextButtonDisabled,
    } = this.props;
    return (
      <div className="btn-bar ">
        <Row>
          <Col sm={5}>
            {hasBackButton && (
              <Link
                className="btn-secondary red back-btn btn"
                to={backTo}
                disabled={submitting}
              >
                Retour à la page précédente
              </Link>
            )}
          </Col>
          <Col sm={7}>
            {hasNextButton && (
              <Button
                type={isInPaymentPage ? 'button' : onClickSubmit ? 'button' : 'submit'}
                className="continue-btn btn-secondary red"
                onClick={onClickSubmit}
                disabled={submitting || (submitFailed && !valid) || nextButtonDisabled}
              >
                {submitting ? (
                  <FaSpinner className="fa-spin spin-icon"/>
                ) : (
                  isInPaymentPage ? 'Valider le paiement' : nextButtonText
                )}
              </Button>
            )}
            {saveQuoteModal}
          </Col>
        </Row>
      </div>
    );
  }
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/NavigationBar/index.tsx